import {
  ChangeDetectionStrategy,
  Component,
  computed,
  contentChild,
  Directive,
  input,
  output,
} from '@angular/core';
import {
  EventqSearchableList,
  type EventqSearchableListColumn,
  type EventqSearchableListRow,
} from '../searchable-list/searchable-list';

export interface EventqCollapsibleSearchItem {
  id: string;
  label: string;
}

/** Projects custom body content into `eventq-collapsible-search-panel`. */
@Directive({
  selector: '[eventqCollapsibleSearchPanelBody]',
})
export class EventqCollapsibleSearchPanelBody {}

const ITEM_COLUMNS: EventqSearchableListColumn[] = [{ key: 'label', style: 'primary' }];

@Component({
  selector: 'eventq-collapsible-search-panel',
  imports: [EventqSearchableList],
  templateUrl: './collapsible-search-panel.html',
  styleUrl: './collapsible-search-panel.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: {
    '[class.eventq-collapsible-search-panel-host--fill]': 'fillHeight()',
    '[class.eventq-collapsible-search-panel-host--pad-bottom]': 'padListBottom()',
  },
})
export class EventqCollapsibleSearchPanel {
  readonly title = input.required<string>();
  readonly open = input(true);
  readonly fillHeight = input(false);
  /** When fillHeight is true, keep list at natural height and pad empty space below it. */
  readonly padListBottom = input(false);
  readonly searchPlaceholder = input('Search');
  readonly searchQuery = input('');
  readonly items = input.required<EventqCollapsibleSearchItem[]>();
  readonly selectedId = input<string | null>(null);

  readonly openChange = output<boolean>();
  readonly searchQueryChange = output<string>();
  readonly itemSelect = output<string>();

  readonly itemColumns = ITEM_COLUMNS;
  private readonly customBody = contentChild(EventqCollapsibleSearchPanelBody);
  readonly showItemRows = computed(() => !this.customBody());

  readonly itemRows = computed<EventqSearchableListRow[]>(() =>
    this.items().map((item) => ({ id: item.id, label: item.label })),
  );

  readonly selectedIds = computed(() => {
    const id = this.selectedId();
    return id ? [id] : [];
  });

  toggleOpen(): void {
    this.openChange.emit(!this.open());
  }
}
